import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps } from '../../utils/mobx.utils';
import './AppPageContent.scss';
var AppPageContent = function (props) {
    var p = useProps(props);
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('AppPageContent', p.className, p.padSections && 'padSections') }, props.children)); } });
};
export default AppPageContent;
